import React, { useState, useEffect } from 'react'
import classNames from 'classnames'

import List from '../features/completions/List'
import Footer from '../features/completions/Footer'
import Channel from '../features/completions/Channel'
import Header from '../components/Header'
import PersonaSelection from '../components/PersonaSelection'

interface Props {
  close: () => void
  isClosing?: boolean
  initialMessage?: string
}

type ViewMode = 'chat' | 'persona-selection'

function FastActionChat({ close, isClosing = false, initialMessage }: Props) {
  const [isInitialMount, setIsInitialMount] = useState(true)
  const [currentView, setCurrentView] = useState<ViewMode>('chat')
  const [localInitialMessage, setLocalInitialMessage] = useState<string | undefined>(initialMessage)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsInitialMount(false)
    }, 50)

    return () => clearTimeout(timer)
  }, [])

  useEffect(() => {
    setLocalInitialMessage(initialMessage)
  }, [initialMessage])

  useEffect(() => {
    if (currentView === 'persona-selection') {
      setLocalInitialMessage(undefined)
    }
  }, [currentView])

  const chatClassNames = classNames({
    'pilot-faw-chat': true,
    'pilot-faw-chat--closing': isClosing,
    'pilot-faw-chat--animating': isInitialMount,
    'pilot-faw-chat--visible': !isClosing && !isInitialMount,
  })

  const handlePersonaClick = () => {
    setCurrentView('persona-selection')
  }

  const handleBackToChat = () => {
    setCurrentView('chat')
  }

  const renderContent = () => {
    switch (currentView) {
      case 'persona-selection':
        return <PersonaSelection onBack={handleBackToChat} />
      case 'chat':
      default:
        return (
          <>
            <Channel>
              <List bodyScroll={false} />
            </Channel>
            <Footer initialMessage={localInitialMessage} />
          </>
        )
    }
  }

  return (
    <div className={chatClassNames}>
      <Header close={close} onPersonaClick={handlePersonaClick} />
      {renderContent()}
    </div>
  )
}

export default FastActionChat
